import {
  WhatsappTemplateCategories,
  WhatsappTemplateStatus,
  WhatsappTemplateStates,
  WhatsappTemplateTypes,
  WhatsappTemplateButtons,
  WhatsappTemplateTypeButtons,
  WhatsappTemplateTypeSpecificButtons,
  WhatsappTemplateTypeCall,
} from "./enums";

import { ChannelType } from "@/app/shared/utils/enums";

export const templateCategoriesOptions = [
  { value: "", label: "Todas las categorías" },
  {
    value: WhatsappTemplateCategories.Marketing,
    label: "Marketing",
    info: "Plantillas que incluyen promociones u ofertas, actualizaciones informativas o invitaciones para que los clientes respondan o tomen acción.",
  },
  {
    value: WhatsappTemplateCategories.Transactional,
    label: "Utility",
    info: "Plantillas para solicitudes o transacciones específicas, incluyendo actualizaciones a clientes sobre transacciones en curso, notificaciones de compra, extracción de facturaciones y más.",
  },
  {
    value: WhatsappTemplateCategories.OTP,
    label: "Authentication",
    info: "Plantillas que permiten a las empresas autenticar a los usuarios con contraseñas de un solo uso. Por ejemplo, verificación de cuentas, recuperación de cuentas, desafíos de integridad.",
  },
];

export const templateStatesOptions = [
  { value: "", label: "Todos los estados" },
  { value: WhatsappTemplateStates.Pending, label: "Pendiente" },
  { value: WhatsappTemplateStates.Approved, label: "Aprobado" },
  { value: WhatsappTemplateStates.Rejected, label: "Rechazado" },
  { value: WhatsappTemplateStates.Failed, label: "Fallido" },
];

export const templateStatusOptions = [
  { value: "", label: "Activos / Inactivos" },
  { value: WhatsappTemplateStatus.Active, label: "Activos" },
  { value: WhatsappTemplateStatus.Inactive, label: "Inactivos" },
];

export const templateTypeCategoriesOptions = [
  { value: WhatsappTemplateTypes.Text, label: "Texto" },
  { value: WhatsappTemplateTypes.TextAndImage, label: "Texto e imagen" },
  { value: WhatsappTemplateTypes.TextAndDocument, label: "Texto y documento" },
  { value: WhatsappTemplateTypes.TextAndVideo, label: "Texto y video" },
];

export const templateButtonOptions = [
  { value: WhatsappTemplateButtons.WithoutButton, label: "Sin botones" },
  { value: WhatsappTemplateButtons.WithButton, label: "Con botones" },
];

export const templateTypeButtonOptions = [
  {
    value: WhatsappTemplateTypeButtons.CallToAction,
    label: "Llamada a la acción",
  },
  {
    value: WhatsappTemplateTypeButtons.QuickReply,
    label: "Respuesta rápida",
  },
];

export const templateTypeSpecificButtonOptions = [
  {
    value: WhatsappTemplateTypeSpecificButtons.PhoneNumber,
    label: "Llamada",
    info: "(Se ha llegado al límite)",
  },
  {
    value: WhatsappTemplateTypeSpecificButtons.Url,
    label: "URL",
    info: "(Se ha llegado al límite)",
  },
];

export const templateTypeCall = [
  {
    value: WhatsappTemplateTypeCall.WhatsappVoice,
    label: "Whatsapp Voice",
    info: "Llamada por Waba de voice",
    iconType: ChannelType.Whatsapp,
  },
  {
    value: WhatsappTemplateTypeCall.CustomDestination,
    label: "Número externo",
    info: "Llamada por did",
    iconType: ChannelType.Voice,
  },
];